module.exports = __webpack_public_path__ + "static/sport/bgi-h5.a999d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart/bgi-h5.jpg
// module id = mvYF
// module chunks = 0